import type { I18nLocale } from '@ardoq/i18n';
import { applyServerSideError, applyServerSideSuccess } from '@ardoq/table';
import type {
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from 'ag-grid-enterprise';
import { mergeScopeDataIntoInventoryContext } from '../mergeScopeDataIntoInventoryContext';
import { mapAgGridParamsToReferenceBatchParams } from './mapAgGridParamsToReferenceBatchParams';
import type {
  FetchNextReferenceRowsBatchFunction,
  NextReferenceRowsBatchResult,
  ReferenceInventoryContext,
  ReferenceInventoryRow,
} from './types';

const applyNextReferenceRowsBatchResultInAgGrid = (
  params: IServerSideGetRowsParams<ReferenceInventoryRow>,
  nextRowsBatchOrError: NextReferenceRowsBatchResult,
  i18nLocale: I18nLocale
): void => {
  if (nextRowsBatchOrError.status === 'error') {
    applyServerSideError({
      params,
      error: nextRowsBatchOrError.error,
      i18nLocale,
    });
    return;
  }

  const { rows, totalNumberOfRows, apiScopeData } = nextRowsBatchOrError.result;
  mergeScopeDataIntoInventoryContext(params.api, apiScopeData);
  applyServerSideSuccess({ params, rows, total: totalNumberOfRows });
};

export const getReferenceServerSideDatasource = (
  getNextRowsBatch: FetchNextReferenceRowsBatchFunction
): IServerSideDatasource<ReferenceInventoryRow> => ({
  getRows: async params => {
    const nextRowsBatchOrError = await getNextRowsBatch(
      mapAgGridParamsToReferenceBatchParams(params)
    );
    const { i18nLocale } = params.context as ReferenceInventoryContext;
    applyNextReferenceRowsBatchResultInAgGrid(
      params,
      nextRowsBatchOrError,
      i18nLocale
    );
  },
});
